<div class="box">
    <div class="itax-body">
        <div class="container position-relative w-100 h-100">
            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <h2 class="h2 w-100 text-center mb-30px">กิจกรรมในงาน iTAX {{year}}</h2>
                </div>
            </div>
            <div class="row d-flex justify-content-center">
                <div class="col-10">
                    <div class="row" *ngFor="let activity of activities; let index = index"
                        [class.pb-30px] = "index !== activities?.length - 1">
                        <div [ngClass]="index%2 ? 'd-sm-block d-md-none d-lg-none col pb-10px' : 'col-sm-12 col-md-6 pb-10px'">
                            <img [src]="activity.img" width="100%" height="100%" class="img-activity" alt="activity" title="activity">
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="h2 mb-10px">
                                {{activity.title}}
                            </div>
                            <ng-container *ngIf="!activity.isLocation">
                                <div class="p2 mb-20px sub-text text-gray-medium">
                                    {{activity.content}}
                                </div>
                                <div class="d-flex align-items-center pointer">
                                    <a class="text-center font-primary link" [href]="activity.linkUrl" target="_blank">{{activity.linkTitle}}</a>
                                    <img src="/assets/images/ico-arrow-right-green.svg" alt="arrow" title="arrow">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="activity.isLocation">
                                <div class="p2 sub-text text-gray-medium">
                                    {{activity.content}}
                                    <a class="text-primary" [href]="activity.linkUrl" target="_blank">{{activity.linkTitle}}</a>
                                </div>
                                <div class="p2 mb-20px sub-text text-gray-medium">{{activity.content2}}</div>
                                <div class="p2 mb-20px sub-text text-gray-medium">{{activity.content3}}</div>
                            </ng-container>
                        </div>
                        <div *ngIf="index%2" class="d-none d-md-block d-lg-block col-md-6">
                            <img [src]="activity.img" width="100%" height="100%" class="img-activity" alt="activity" title="activity">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
